import React from 'react'
import AlertModal from './AlertModal';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';
import { useTranslation } from 'react-i18next';

const ShowWizardInfoModal = (props) => {

  const { t } = useTranslation();
  const modalTitle = props.formObject.title || t( 'modal.wizard_info.default_title' );
  const ht = useCustomHtmlTranslation();

  return (
    <AlertModal
      modalTitle={ modalTitle }
    >
    { ht(props.formObject.text) }
    </AlertModal>
  )
}

export default ShowWizardInfoModal



// WEBPACK FOOTER //
// ./src/components/Modals/ShowWizardInfoModal.js